import Client from './Client';

export default class AccountClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取账号列表
   */
  async getList(data) {
    const res = await this.client.post('/api/user/pageBackend', data);
    return res;
  }

  /**
   * 禁用/启用账号
   * @param
   * identityId id
   * identityValid 10 30
   */
  async updateEntityValid(data) {
    const res = await this.client.post('/api/user/updateIdentityValid', data);
    return res;
  }

  /**
   * info
   * @param
   * id
   */
  async getInfo(id) {
    const res = await this.client.post('/api/user/getBackendInfo', { id });
    return res;
  }

  /**
   * 查询权限列表
   *
   */
  async permissionList(data) {
    const res = await this.client.post('/api/user/listPermission', data);
    return res;
  }

  /**
   * 新增修改后台用户
   *
   */
  async upsertBackendUser(data) {
    const res = await this.client.post('/api/user/upsertBackendUser', data);
    return res;
  }

  /**
   * 重置密码
   *
   */
  async resetPsw(data) {
    const res = await this.client.post('/api/user/resetPassword', data);
    return res;
  }

  /**
   * 修改密码
   *
   */
  async updatePassword(data) {
    const res = await this.client.post('/api/user/updatePassword', data);
    return res;
  }
}